import { render, staticRenderFns } from "./SafariItineraryDayEditor.vue?vue&type=template&id=68daa441&scoped=true&"
import script from "./SafariItineraryDayEditor.vue?vue&type=script&lang=js&"
export * from "./SafariItineraryDayEditor.vue?vue&type=script&lang=js&"
import style0 from "./SafariItineraryDayEditor.vue?vue&type=style&index=0&id=68daa441&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68daa441",
  null
  
)

export default component.exports